import React from "react";

export default function Footer() {
  return (
    <React.Fragment>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6">
              {new Date().getFullYear()} © Copyright{" "}
              <strong>
                <span>Swallow Events</span>
              </strong>
              . All Rights Reserved
            </div>
            <div className="col-sm-6">
              <div className="text-sm-end d-none d-sm-block">
                Swallow Events
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
}
